import { render, staticRenderFns } from "./previleges.vue?vue&type=template&id=b3914d80"
import script from "./previleges.vue?vue&type=script&lang=js"
export * from "./previleges.vue?vue&type=script&lang=js"
import style0 from "./previleges.vue?vue&type=style&index=0&id=b3914d80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports